module.exports = new __parcel__URL__("multishot.9219ed09.png").toString();